import image from '../assets/Bitdefender-logo.png';

import styles from '../styles/base_components/Page.module.scss';

function BitdefenderLogo(props) {
  return (
    <div className={styles.bitdefenderLogo}>
      <img src={image} alt='Bitdefender Logo'/>
    </div>
  );
}

export default BitdefenderLogo;